import i18n from '../../../i18n';

const CustomerValidate = values => {
  const errors = {};
  const requiredFields = [
    'email',
    'password',
    'confirmPassword',
    'userName',
    'password',
    'currentPassword',
    'newPassword',
    'confirmPassword',
  ];
  requiredFields.forEach(field => {
    if (
      !values[field] ||
      (values[field] &&
        isNaN(parseInt(values[field])) &&
        values[field].trim() === '')
    ) {
      errors[field] = i18n.t('required');
    }
  });
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = i18n.t('invalid_email_input_error');
  }

  if (values.password && !/^(?!.* ).{8,}$/.test(values.password)) {
    errors.password = i18n.t('PasswordFormatMsg');
  }

  if (values.newPassword && !/^(?!.* ).{8,}$/.test(values.newPassword)) {
    errors.newPassword = i18n.t('PasswordFormatMsg');
  }
  return errors;
};

export default CustomerValidate;
